import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, CreditCard } from "lucide-react";
import { BRAND } from "@/lib/constants";

const GALLERY_ID = "galeri-design";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const goGallery = () => {
    setOpen(false);
    if (pathname === "/") {
      document.getElementById(GALLERY_ID)?.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/#${GALLERY_ID}`);
    }
  };

  const items = [
    { label: "Utama", onClick: () => { setOpen(false); navigate("/"); }, testId: "nav-utama" },
    { label: "Pilih Design", onClick: goGallery, testId: "nav-pilih-design" },
    { label: "Semak Tempahan", onClick: () => { setOpen(false); navigate("/semak"); }, testId: "nav-semak-tempahan" },
  ];

  return (
    <header className="sticky top-0 z-50 bg-[#fbfaf6]/85 backdrop-blur-md border-b border-[#0f3f2f]/10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" data-testid="brand-link" className="flex items-center gap-2.5">
            <span className="grid place-items-center h-9 w-9 rounded-xl bg-gradient-to-br from-[#12876a] to-[#0f3f2f] text-white">
              <CreditCard strokeWidth={1.75} className="h-[18px] w-[18px]" />
            </span>
            <span className="font-heading font-extrabold text-lg text-[#0f3f2f]">{BRAND}</span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="Navigasi utama">
            {items.map((i) => (
              <button
                key={i.label}
                type="button"
                onClick={i.onClick}
                data-testid={i.testId}
                className="px-3.5 py-2 rounded-full text-sm font-medium text-[#4a5a53] hover:text-[#0f3f2f] hover:bg-[#0f3f2f]/5 transition-colors duration-200"
              >
                {i.label}
              </button>
            ))}
          </nav>

          <button
            type="button"
            aria-label="Buka menu"
            aria-expanded={open}
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden grid place-items-center h-11 w-11 rounded-xl border border-[#0f3f2f]/15 text-[#0f3f2f]"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="md:hidden border-t border-[#0f3f2f]/10 bg-white px-4 py-1"
          aria-label="Navigasi mudah alih"
          data-testid="mobile-menu"
        >
          {items.map((i) => (
            <button
              key={i.label}
              type="button"
              onClick={i.onClick}
              data-testid={`mobile-${i.testId}`}
              className="block w-full text-left px-2 py-3.5 text-base font-medium text-[#14201b] border-b border-[#0f3f2f]/10 last:border-0"
            >
              {i.label}
            </button>
          ))}
        </nav>
      )}
    </header>
  );
};
